// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fX4JN","colMin":"styles_colMin__NL3iN"};